import { DropDown, FormControls } from '@elementary/common-ui/components';
import { Tooltip } from '@mui/material';
import { Control, Controller } from 'react-hook-form';
import { AddTestForm } from 'shared/types';

type Props = {
  title?: string;
  control: Control<AddTestForm, any>;
  options: { value: string; label: string }[];
  name?: keyof Pick<
    AddTestForm,
    'timestampColumn' | 'updatedAtTimestampColumn'
  >;
  placeholder?: string;
};

const TimestampColumnFormField = ({
  title = 'Provide timestamp column',
  control,
  options,
  name = 'timestampColumn',
  placeholder = 'Timestamp column',
}: Props) => (
  <FormControls.Row>
    <FormControls.FormText>{title}:</FormControls.FormText>
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Tooltip
          title={
            options.length
              ? ''
              : 'To proceed, make sure the selected tables share a common timestamp column'
          }
        >
          <DropDown
            placeholder={placeholder}
            size="large"
            options={options}
            {...field}
            value={field.value}
            disabled={!options.length}
          />
        </Tooltip>
      )}
    />
  </FormControls.Row>
);

export default TimestampColumnFormField;
